import { createSelector } from "reselect";
import { getProducts } from "./getProducts";
import getRegion from "./getRegion";

const stateWishlist = state => state.wishlist.products;
const stateWishlistForm = state => state.wishlist.emailForm;

const getWishlist = createSelector(
  [stateWishlist, getProducts],
  (wishlist, products) => {
    return products.filter(product => wishlist.includes(product.sku))
  }
);

const getWishlistEmailRequest = createSelector(
  [getRegion, stateWishlist, stateWishlistForm],
  (region, products, form) => {
    return {
      language: region.language,
      email: form.email,
      products
    }
  }
);


export { getWishlist, getWishlistEmailRequest };
